<template>
  <div class="bidder-analysis">
    <div class="page-header">
      <h2>投标人分析</h2>
      <p>查看投标人竞争力</p>
    </div>


    <div class="page-content">
      <el-form :inline="true" style="margin-bottom: 12px;">
        <el-form-item label="选择投标人：">
          <el-input v-model="bidderName" placeholder="请选择投标人" readonly style="width: 240px;" @click="openBidderDialog">
            <el-button slot="append" icon="el-icon-search" @click="openBidderDialog"></el-button>
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" :disabled="!bidderId" @click="loadData">分析</el-button>
          <el-button type="success" :disabled="!bidderId" @click="exportCsv">导出CSV</el-button>
        </el-form-item>
      </el-form>

      <el-card v-if="summary" style="margin-bottom: 12px;">
        <div>参与包数量：{{ summary.participated_packages }}</div>
        <div>平均排名：{{ summary.average_rank && summary.average_rank.toFixed(2) }}</div>
        <div>平均价格分：{{ summary.average_price_score && summary.average_price_score.toFixed(2) }}</div>
        <div>最高价格分：{{ summary.max_price_score !== undefined ? Number(summary.max_price_score).toFixed(2) : '' }}</div>
        <div>最低价格分：{{ summary.min_price_score !== undefined ? Number(summary.min_price_score).toFixed(2) : '' }}</div>
      </el-card>

      <el-table :data="items" v-loading="loading" @sort-change="onSortChange" style="width: 100%">
        <el-table-column prop="package_name" label="主包/项目" min-width="200" />
        <el-table-column prop="sub_package_name" label="分包名称" min-width="200" />
        <el-table-column prop="sub_package_no" label="分包编号" width="160" />
        <el-table-column prop="unit_name" label="单位" min-width="160" />
        <el-table-column prop="bid_price" label="投标价格" width="120" sortable="custom">
          <template slot-scope="scope">¥{{ Number(scope.row.bid_price).toFixed(2) }}</template>
        </el-table-column>
        <el-table-column prop="unit_price" label="单价" width="120" sortable="custom">
          <template slot-scope="scope">¥{{ Number(scope.row.unit_price).toFixed(2) }}</template>
        </el-table-column>
        <el-table-column prop="price_score" label="价格分" width="100" sortable="custom">
          <template slot-scope="scope">{{ Number(scope.row.price_score).toFixed(2) }}</template>
        </el-table-column>
        <el-table-column prop="max_price_score" label="包内最高分" width="120" sortable="custom">
          <template slot-scope="scope">{{ Number(scope.row.max_price_score).toFixed(2) }}</template>
        </el-table-column>
        <el-table-column prop="min_price_score" label="包内最低分" width="120" sortable="custom">
          <template slot-scope="scope">{{ Number(scope.row.min_price_score).toFixed(2) }}</template>
        </el-table-column>
        <el-table-column prop="rank" label="包内排名" width="100" sortable="custom" />
        <el-table-column prop="total_in_package" label="包内总数" width="100" />
        <el-table-column prop="all_average_price" label="所有均价" width="140">
          <template slot-scope="scope">¥{{ Number(scope.row.all_average_price).toFixed(2) }}</template>
        </el-table-column>
        <el-table-column prop="valid_average_price" label="有效均价" width="140">
          <template slot-scope="scope">¥{{ Number(scope.row.valid_average_price).toFixed(2) }}</template>
        </el-table-column>
        <el-table-column prop="base_price" label="基准价" width="140">
          <template slot-scope="scope">¥{{ Number(scope.row.base_price).toFixed(2) }}</template>
        </el-table-column>
        <el-table-column prop="created_at" label="创建时间" width="170" />
      </el-table>

      <div style="margin-top: 12px; text-align: center;">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="page"
          :page-size="size"
          :total="total"
          layout="prev, pager, next, total">
        </el-pagination>
      </div>
    </div>

    <BidderSelectDialog :visible.sync="showBidderDialog" @select="selectBidder" />
  </div>
</template>

<script>
import axios from 'axios'
import BidderSelectDialog from '../components/BidderSelectDialog.vue'

export default {
  name: 'BidderAnalysis',
  components: { BidderSelectDialog },
  data() {
    return {
      loading: false,
      bidderId: null,
      bidderName: '',
      summary: null,
      items: [],
      total: 0,
      page: 1,
      size: 10,
      sortBy: '',
      sortDir: '',
      showBidderDialog: false
    }
  },
  methods: {
    openBidderDialog() {
      this.showBidderDialog = true
    },
    selectBidder(bidder) {
      this.bidderId = bidder.id
      this.bidderName = bidder.name
      this.page = 1
      this.loadData()
    },
    async loadData() {
      if (!this.bidderId) return
      this.loading = true
      try {
        const { data } = await axios.get('/import/bidder-analysis', { params: { bidder_id: this.bidderId, page: this.page, size: this.size, sort_by: this.sortBy, sort_dir: this.sortDir } })
        const res = data.data || data
        this.summary = res.summary
        this.items = res.items
        this.total = res.total
      } finally {
        this.loading = false
      }
    },
    handleCurrentChange(p) {
      this.page = p
      this.loadData()
    },
    onSortChange({ prop, order }) {
      this.sortBy = prop || ''
      this.sortDir = order === 'descending' ? 'DESC' : (order === 'ascending' ? 'ASC' : '')
      this.page = 1
      this.loadData()
    },
    exportCsv() {
      if (!this.bidderId) return
      const params = new URLSearchParams()
      params.append('bidder_id', this.bidderId)
      if (this.sortBy) params.append('sort_by', this.sortBy)
      if (this.sortDir) params.append('sort_dir', this.sortDir)
      const url = `/import/bidder-analysis/export?${params.toString()}`
      window.open(url, '_blank')
    }
  }
}
</script>

<style scoped>
.page-header { margin-bottom: 20px; }
.page-header h2 { margin: 0 0 10px 0; color: #303133; }
.page-header p { margin: 0; color: #909399; }
</style>


